(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["coming-soon"]) return;
  try {
    
  // The crying face opens the password field in place of the sign-up.
  (function () {
    var toggle = document.querySelector('[data-cs-login-toggle]');
    var login = document.querySelector('[data-cs-login]');
    if (!toggle || !login) return;
    var signup = document.querySelector('[data-cs-signup]');
    var field = login.querySelector('input[type="password"]');

    function set(open, focus) {
      login.hidden = !open;
      if (signup) signup.hidden = open;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open && focus && field) field.focus();
    }

    toggle.addEventListener('click', function () { set(login.hidden, true); });

    // Back from a wrong password: show the field and the reason straight away.
    if (login.querySelector('[data-cs-login-error]')) set(true, true);
  })();

(function () {
  var CLICK_SLOP = 8;   // px of travel still counted as a click, not a drag
  var CLICK_TIME = 500; // ms

  function initSection(section) {
    var stack = section.querySelector('[data-cs-stack]');
    if (!stack) return;

    var cards = Array.prototype.slice.call(stack.querySelectorAll('[data-cs-card]'));
    if (!cards.length) return;

    var css = getComputedStyle(section);
    var maxZoom = parseFloat(css.getPropertyValue('--cs-max-zoom')) || 3;
    var scatter = parseFloat(css.getPropertyValue('--cs-scatter'));
    var tilt = parseFloat(css.getPropertyValue('--cs-tilt'));
    if (isNaN(scatter)) scatter = 40;
    if (isNaN(tilt)) tilt = 12;
    var minZoom = 1;
    var margin = 48; // px of a drawing that must stay on screen

    function rand(min, max) { return min + Math.random() * (max - min); }
    function dist(a, b) { return Math.hypot(a.x - b.x, a.y - b.y); }
    function mid(a, b) { return { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 }; }
    function clampScale(s) { return Math.min(maxZoom, Math.max(minZoom, s)); }

    // The original artwork (first card) stays square-on at the top of the pile;
    // the rest are shuffled and scattered underneath, fresh on every page load.
    var hero = cards[0];
    var buried = cards.slice(1);
    for (var i = buried.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var swap = buried[i]; buried[i] = buried[j]; buried[j] = swap;
    }
    var order = [hero].concat(buried); // index 0 == top of the pile

    var state = new Map();
    cards.forEach(function (card) {
      state.set(card, {
        x: card === hero ? 0 : rand(-scatter, scatter),
        y: card === hero ? 0 : rand(-scatter, scatter),
        r: card === hero ? 0 : rand(-tilt, tilt),
        scale: 1,
        base: null
      });
    });

    function apply(card) {
      var s = state.get(card);
      card.style.transform =
        'translate(' + s.x + 'px,' + s.y + 'px) rotate(' + s.r + 'deg) scale(' + s.scale + ')';
    }

    function applyOrder() {
      order.forEach(function (card, idx) {
        card.style.zIndex = String(order.length - idx);
      });
    }

    // Click anywhere on the pile: the bottom drawing surfaces to the top.
    function cycle() {
      if (order.length < 2) return;
      order.unshift(order.pop());
      applyOrder();
    }

    // Measure a card's untransformed drawing (the image, not its full-bleed box).
    function measure(card) {
      var s = state.get(card);
      var prev = card.style.transform;
      card.style.transform = 'none';
      var img = card.querySelector('img');
      var r = (img || card).getBoundingClientRect();
      card.style.transform = prev;
      s.base = { cx: r.left + r.width / 2, cy: r.top + r.height / 2, w: r.width, h: r.height };
    }

    // Keep a drawing from leaving the viewport (at least `margin` px stays visible).
    function clampTranslate(card) {
      var s = state.get(card);
      if (!s.base) return;
      var halfW = (s.base.w * s.scale) / 2;
      var halfH = (s.base.h * s.scale) / 2;
      var cx = s.base.cx + s.x;
      var cy = s.base.cy + s.y;
      var minCx = margin - halfW, maxCx = window.innerWidth - margin + halfW;
      var minCy = margin - halfH, maxCy = window.innerHeight - margin + halfH;
      cx = Math.min(maxCx, Math.max(minCx, cx));
      cy = Math.min(maxCy, Math.max(minCy, cy));
      s.x = cx - s.base.cx;
      s.y = cy - s.base.cy;
    }

    cards.forEach(function (card) {
      var img = card.querySelector('img');
      if (!img) return;

      var pointers = new Map();
      var gesture = null;
      var travel = 0;
      var downAt = 0;

      function baseline() {
        var s = state.get(card);
        var pts = Array.from(pointers.values());
        gesture = { x: s.x, y: s.y, scale: s.scale };
        if (pts.length >= 2) {
          gesture.dist = dist(pts[0], pts[1]);
          gesture.mid = mid(pts[0], pts[1]);
        } else if (pts.length === 1) {
          gesture.mid = { x: pts[0].x, y: pts[0].y };
        }
      }

      img.addEventListener('pointerdown', function (e) {
        img.setPointerCapture(e.pointerId);
        pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
        if (pointers.size === 1) {
          travel = 0;
          downAt = e.timeStamp;
          measure(card);
        }
        card.classList.add('is-grabbing');
        baseline();
      });

      img.addEventListener('pointermove', function (e) {
        if (!pointers.has(e.pointerId) || !gesture) return;
        var prev = pointers.get(e.pointerId);
        travel += Math.hypot(e.clientX - prev.x, e.clientY - prev.y);
        pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });

        var s = state.get(card);
        var pts = Array.from(pointers.values());
        if (pts.length >= 2) {
          var d = dist(pts[0], pts[1]);
          var m = mid(pts[0], pts[1]);
          s.scale = clampScale(gesture.scale * (d / gesture.dist));
          s.x = gesture.x + (m.x - gesture.mid.x);
          s.y = gesture.y + (m.y - gesture.mid.y);
        } else {
          var p = pts[0];
          s.x = gesture.x + (p.x - gesture.mid.x);
          s.y = gesture.y + (p.y - gesture.mid.y);
        }
        clampTranslate(card);
        apply(card);
      });

      function release(e) {
        if (!pointers.has(e.pointerId)) return;
        pointers.delete(e.pointerId);
        if (pointers.size === 0) {
          gesture = null;
          card.classList.remove('is-grabbing');
          // Barely moved, released quickly? That was a click, not a drag.
          if (travel < CLICK_SLOP && (e.timeStamp - downAt) < CLICK_TIME) cycle();
        } else {
          baseline(); // re-baseline the remaining pointer(s)
        }
      }
      img.addEventListener('pointerup', release);
      img.addEventListener('pointercancel', release);

      img.addEventListener('click', function (e) { e.preventDefault(); });
    });

    function remeasure() {
      cards.forEach(function (card) {
        measure(card);
        clampTranslate(card);
        apply(card);
      });
    }

    applyOrder();
    cards.forEach(apply);

    cards.forEach(function (card) {
      var img = card.querySelector('img');
      if (img && !img.complete) img.addEventListener('load', function () {
        measure(card);
        clampTranslate(card);
        apply(card);
      });
    });
    window.addEventListener('resize', remeasure);
    window.addEventListener('load', remeasure);
    remeasure();
  }

  document.querySelectorAll('[data-section-type="coming-soon"]').forEach(initSection);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  // Sign-up states. The server's answer arrives as markup after the round
  // trip; this picks it up and hands it to the panel so the stars can read it.
  // A missing or malformed address never makes the trip: it is caught here,
  // with the same red, so the answer is immediate.
  (function () {
    document.querySelectorAll('[data-gw-signup-panel]').forEach(function (panel) {
      var form = panel.querySelector('.gw-footer__form');
      if (!form) return;
      var field = form.querySelector('input[type="email"]');
      var note = form.querySelector('[data-gw-signup-note]');

      function state(name) {
        panel.classList.remove('is-error', 'is-success');
        if (name) { void panel.offsetWidth; panel.classList.add('is-' + name); }
      }

      var served = form.querySelector('[data-gw-signup-state]');
      if (served) state(served.getAttribute('data-gw-signup-state'));
      if (!field) return;

      // Ours, not the browser's bubble — that one cannot be styled and says
      // nothing in the page a screen reader can return to.
      form.setAttribute('novalidate', '');

      form.addEventListener('submit', function (event) {
        var value = field.value.trim();
        var ok = value !== '' && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
        if (ok) return;
        event.preventDefault();
        field.setAttribute('aria-invalid', 'true');
        if (note) note.textContent = panel.getAttribute('data-gw-signup-invalid') || '';
        state('error');
        field.focus();
      });

      field.addEventListener('input', function () {
        if (!panel.classList.contains('is-error')) return;
        field.removeAttribute('aria-invalid');
        if (note) note.textContent = '';
        state(null);
      });
    });
  })();

  // The drawing that follows the links, restored — an earlier edit to the star
  // script took this with it. It also now carries the colour wash: one layer
  // masked to whichever drawing is showing, rather than one per drawing.
  (function () {
    document.querySelectorAll('[data-gw-footer]').forEach(function (footer) {
      var stage = footer.querySelector('[data-gw-icon-stage]');
      var scope = footer.querySelector('[data-gw-icon-scope]');
      if (!stage || !scope) return;

      // Desktop only. Without a real pointer there is no hover to answer, so
      // nothing is bound and the resting drawing simply stays.
      var pointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)');
      if (pointer && !pointer.matches) return;

      var images = stage.querySelectorAll('[data-gw-icon-for]');
      var resting = images[0] ? images[0].getAttribute('data-gw-icon-for') : null;
      function show(key) {
        images.forEach(function (img) {
          img.classList.toggle('is-active', img.getAttribute('data-gw-icon-for') === key);
        });
      }

      footer.querySelectorAll('[data-gw-icon]').forEach(function (link) {
        var key = link.getAttribute('data-gw-icon');
        function enter() { show(key); }
        link.addEventListener('mouseenter', enter);
        link.addEventListener('focus', enter);
        link.addEventListener('blur', function () { show(resting); });
      });

      // The reset lives on the list, not on each link. Per-link mouseleave fired
      // on the way from one link to the next, so the sun flashed up between
      // every pair. Leaving the list is the only thing that should reset it.
      scope.addEventListener('mouseleave', function () { show(resting); });

    });
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gw-collections-front"]) return;
  try {
    
  if (!window.__gwCollectionBound) {
  window.__gwCollectionBound = true;
  // Sort genuinely submits: the <select> is a real GET control, and this only
  // saves the visitor a press of Apply. Without JS the noscript button does it.
  document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-gw-sort]');
    if (!select || !select.form) return;
    select.form.submit();
  });

  // Let the filter disclosure behave like one: click away or press Escape.
  document.addEventListener('click', function (event) {
    var open = document.querySelectorAll('[data-gw-filter][open]');
    for (var i = 0; i < open.length; i++) {
      if (!open[i].contains(event.target)) open[i].removeAttribute('open');
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var open = document.querySelectorAll('[data-gw-filter][open]');
    for (var i = 0; i < open.length; i++) {
      open[i].removeAttribute('open');
      var summary = open[i].querySelector('summary');
      if (summary) summary.focus();
    }
  });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gw-region-gate"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-gw-region]');
    if (!root) return;

    var dialog = root.querySelector('dialog');
    var key    = root.getAttribute('data-storage-key') || 'gw-region';
    var days   = parseInt(root.getAttribute('data-days'), 10);
    if (!(days > 0)) days = 30;
    var MAX_AGE = days * 24 * 60 * 60;          // seconds, for the cookie
    var MAX_MS  = MAX_AGE * 1000;               // ms, for the localStorage copy
    if (!dialog || typeof dialog.showModal !== 'function') return;

    var closeBtn = dialog.querySelector('[data-gw-region-close]');
    var labels = {
      geo:  root.getAttribute('data-label-geo')  || 'Georgia',
      intl: root.getAttribute('data-label-intl') || 'International'
    };

    // ---- the cookie --------------------------------------------------------
    // Scoped to the registrable domain so ge.giorgiwazowski.com — the same shop
    // on a second domain — reads the same answer. On localhost or a myshopify
    // preview there is no parent domain worth setting, so Domain is left off
    // and the cookie simply belongs to the host.
    function cookieDomain() {
      var h = location.hostname;
      if (/^(localhost|[\d.]+)$/.test(h)) return '';
      var parts = h.split('.');
      if (parts.length < 2) return '';
      if (h.indexOf('myshopify.com') > -1) return '';
      return '.' + parts.slice(-2).join('.');
    }

    function readCookie() {
      var m = document.cookie.match(new RegExp('(?:^|; )' + key.replace(/[-.]/g, '\\$&') + '=([^;]*)'));
      return m ? decodeURIComponent(m[1]) : null;
    }
    function writeCookie(v) {
      var d = cookieDomain();
      document.cookie = key + '=' + encodeURIComponent(v)
        + '; Max-Age=' + MAX_AGE
        + '; Path=/'
        + (d ? '; Domain=' + d : '')
        + '; SameSite=Lax'
        + (location.protocol === 'https:' ? '; Secure' : '');
    }
    function clearCookie() {
      var d = cookieDomain();
      document.cookie = key + '=; Max-Age=0; Path=/' + (d ? '; Domain=' + d : '');
    }

    // ---- the localStorage mirror -------------------------------------------
    // Stamped, because localStorage never expires on its own. A value left by
    // the previous version of this script is a bare string with no stamp; that
    // is a real answer from a real visitor, so it is adopted and stamped now
    // rather than thrown away, which would re-ask everyone at once.
    function readStore() {
      try {
        var raw = localStorage.getItem(key);
        if (!raw) return null;
        if (raw === 'geo' || raw === 'intl') return { value: raw, legacy: true };
        var o = JSON.parse(raw);
        if (!o || (o.value !== 'geo' && o.value !== 'intl')) return null;
        if (!o.ts || (Date.now() - o.ts) > MAX_MS) return null;
        return o;
      } catch (e) { return null; }
    }
    function writeStore(v) {
      try { localStorage.setItem(key, JSON.stringify({ value: v, ts: Date.now() })); } catch (e) {}
    }
    function clearStore() {
      try { localStorage.removeItem(key); } catch (e) {}
    }

    function remembered() {
      var c = readCookie();
      if (c === 'geo' || c === 'intl') return c;
      var o = readStore();
      if (!o) return null;
      // Found only in storage: either a legacy answer or one made while cookies
      // were unavailable. Re-issue the cookie so it expires on schedule.
      writeCookie(o.value);
      if (o.legacy) writeStore(o.value);
      return o.value;
    }

    function remember(v) { writeCookie(v); writeStore(v); }
    function forget() { clearCookie(); clearStore(); }

    // ---- where each region lives -------------------------------------------
    var urls = {
      geo:  root.getAttribute('data-geo-url')  || '',
      intl: root.getAttribute('data-intl-url') || ''
    };

    // Is this URL the page we are already on? Compared by host, because the
    // two regions are two domains serving the same shop — the path is beside
    // the point, and a trailing slash should not count as a difference.
    function isHere(url) {
      if (!url) return true;
      try { return new URL(url, location.href).host === location.host; }
      catch (e) { return true; }
    }

    // Which region this domain *is*.
    //
    // The cookie records what someone once picked; the domain decides what
    // they are actually being shown, because currency and market come from
    // the domain. The two can drift apart — pick Georgia, then later open a
    // .com link or a bookmark, and you are on the international domain with a
    // cookie that says geo. Everything below trusts this over the cookie.
    function hostRegion() {
      var keys = ['geo', 'intl'];
      for (var i = 0; i < keys.length; i++) {
        var url = urls[keys[i]];
        if (!url) continue;
        try {
          if (new URL(url, location.href).host === location.host) return keys[i];
        } catch (e) {}
      }
      return null;   // a preview domain, or a host neither setting names
    }

    // What to show as current: where you are, falling back to what you chose.
    function showing() { return hostRegion() || remembered(); }

    // The same page on the other domain, not that domain's front door.
    // Switching region used to send you to the homepage, so changing currency
    // halfway down a product cost you the product. Both domains are the same
    // shop on the same theme, so whatever path you are on exists on both.
    // gw-region rides along for anyone whose cookies are blocked.
    function destination(url, region) {
      try {
        var u = new URL(url, location.href);
        u.pathname = location.pathname;
        u.search = location.search;
        u.searchParams.set('gw-region', region);
        return u.href;
      } catch (e) { return url; }
    }

    // ---- the Region controls ------------------------------------------------
    // Three of them, all fed from the same answer: the strip above the nav,
    // which shows both regions and marks the current one; the footer control,
    // which opens the full chooser; and any label that just wants naming.
    function paintSwitches() {
      var current = showing();

      var nodes = document.querySelectorAll('[data-gw-region-label]');
      for (var i = 0; i < nodes.length; i++) {
        nodes[i].textContent = current ? labels[current] : '';
      }

      // Shipped hidden: with no script there is nothing for it to open, and
      // before this runs there is no region to name.
      var opens = document.querySelectorAll('[data-gw-region-open]');
      for (var j = 0; j < opens.length; j++) {
        if (current) opens[j].hidden = false;
      }

      var names = document.querySelectorAll('[data-gw-region-name]');
      for (var k = 0; k < names.length; k++) {
        names[k].textContent = labels[names[k].getAttribute('data-gw-region-name')] || '';
      }

      var picks = document.querySelectorAll('[data-gw-region-pick]');
      for (var m = 0; m < picks.length; m++) {
        var which = picks[m].getAttribute('data-gw-region-pick');
        picks[m].setAttribute('aria-selected', which === current ? 'true' : 'false');
      }

      // The trigger wears the current region: its name, and its mark. Both
      // marks are already in the markup — showing one and hiding the other is
      // cheaper than building either, and keeps the artwork somewhere a person
      // can read it.
      var cur = document.querySelector('[data-gw-region-current]');
      if (cur) cur.textContent = current ? (labels[current] || '') : '';

      var icons = document.querySelectorAll('[data-gw-region-icon]');
      for (var n = 0; n < icons.length; n++) {
        icons[n].hidden = icons[n].getAttribute('data-gw-region-icon') !== current;
      }

      // The strip names a region, so it waits until there is one to name.
      var strip = document.querySelector('[data-gw-util]');
      if (strip && current) strip.hidden = false;
    }

    // ---- the dropdown --------------------------------------------------------
    var trigger = document.querySelector('[data-gw-region-trigger]');
    var menu    = document.querySelector('[data-gw-region-menu]');

    function setMenu(openIt) {
      if (!trigger || !menu) return;
      menu.hidden = !openIt;
      trigger.setAttribute('aria-expanded', openIt ? 'true' : 'false');
    }

    if (trigger && menu) {
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        setMenu(menu.hidden);
      });

      // Anywhere outside closes it. Bound on the document rather than on a
      // blur, because moving from the trigger to an option inside the menu is
      // a blur too and would shut the thing being reached for.
      document.addEventListener('click', function (event) {
        if (menu.hidden) return;
        if (event.target.closest && event.target.closest('[data-gw-region-select]')) return;
        setMenu(false);
      });

      document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape' || menu.hidden) return;
        setMenu(false);
        trigger.focus();
      });
    }

    // ---- opening ------------------------------------------------------------
    var html = document.documentElement;
    var mode = 'gate';

    function open(which) {
      mode = which;
      if (closeBtn) closeBtn.hidden = (mode !== 'switch');
      root.hidden = false;
      if (mode === 'gate') html.classList.add('gw-gate-open');  // hold the cookie banner back
      if (!dialog.open) dialog.showModal();
      var title = dialog.querySelector('.gw-region__title');
      if (title) title.focus({ preventScroll: true });
    }

    function close() {
      if (dialog.open) dialog.close();
    }

    document.addEventListener('click', function (event) {
      if (!event.target.closest) return;

      var opener = event.target.closest('[data-gw-region-open]');
      if (opener) {
        event.preventDefault();
        open('switch');
        return;
      }

      // The strip switches directly. With two regions a dialog asking which of
      // two you meant, when you just clicked one of two, is a question already
      // answered. The dialog stays for arrival, and for the footer control.
      var pick = event.target.closest('[data-gw-region-pick]');
      if (!pick) return;
      event.preventDefault();
      var which = pick.getAttribute('data-gw-region-pick');
      if (which !== 'geo' && which !== 'intl') return;

      // No early return on "the cookie already says this". That check was the
      // bug: land on the international domain carrying a geo cookie — a
      // bookmark, a shared link, anything that is not the switcher — and
      // tapping Georgia did nothing at all, because the code believed you
      // were already there. The only question that matters is whether the
      // region you want lives somewhere else, and isHere answers it.
      remember(which);
      setMenu(false);
      // Each region is a domain. Staying put while claiming to have moved is
      // the bug this whole control exists to fix, so if the region lives
      // somewhere else, go there; the cookie is already set and spans both.
      if (!isHere(urls[which])) {
        location.href = destination(urls[which], which);
        return;
      }
      paintSwitches();
    });

    if (closeBtn) closeBtn.addEventListener('click', close);

    // Escape fires `cancel` before `close`. Refusing it is the only way to keep
    // a modal dialog open, since there is no attribute for it — but only the
    // arrival gate refuses.
    dialog.addEventListener('cancel', function (event) {
      if (mode === 'gate') event.preventDefault();
    });

    dialog.addEventListener('click', function (event) {
      var choice = event.target.closest('[data-gw-region-choice]');
      if (!choice) {
        // Outside the panel is the backdrop. It dismisses a switch, never a gate.
        if (mode === 'switch' && !event.target.closest('.gw-region__panel')) close();
        return;
      }
      var picked = choice.getAttribute('data-gw-region-choice');
      remember(picked);
      paintSwitches();

      // the Georgia option is a real link — let it navigate on its own
      if (choice.tagName === 'A') return;

      event.preventDefault();
      // International is a button, which was fine while it only ever meant
      // "stay here". Opened from the Georgian domain it meant the opposite,
      // and leaving someone on ge. while telling them they are International
      // is exactly the mismatch this is supposed to cure.
      if (!isHere(urls[picked])) {
        location.href = destination(urls[picked], picked);
        return;
      }
      close();
    });

    dialog.addEventListener('close', function () {
      html.classList.remove('gw-gate-open');
      root.hidden = true;
      mode = 'gate';
    });

    // ---- on load ------------------------------------------------------------
    // The gw-region parameter does three jobs:
    //   reset      forget the answer and ask again
    //   geo, intl  an answer arriving from the other domain — record it and
    //              stay quiet, so nobody is asked twice for the same thing
    var param = (location.search.match(/[?&]gw-region=([a-z]+)/) || [])[1];
    if (param === 'reset') {
      forget();
    } else if (param === 'geo' || param === 'intl') {
      remember(param);
    }

    paintSwitches();

    // The gate's Georgia option is a real link, and stays one — middle-click
    // and open-in-new-tab should work. It just gets pointed at the current
    // page rather than the Georgian homepage.
    var geoLink = dialog.querySelector('a[data-gw-region-choice="geo"]');
    if (geoLink && !isHere(urls.geo)) geoLink.href = destination(urls.geo, 'geo');

    // Never interrupt someone with a current answer, and never ask inside the
    // theme editor, where an undismissable dialog would block the preview.
    if (remembered()) return;
    if (window.Shopify && window.Shopify.designMode) return;

    open('gate');
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('.gw-header__toggle');

    if (toggle) {
      var drawer = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!drawer) return;
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      drawer.hidden = open;
      return;
    }

    // A tap anywhere else closes it — but not one inside the panel, which is
    // where the links are. There is no backdrop to catch this, since the menu
    // is an island rather than a full-screen overlay, so it listens on the
    // document instead.
    var open_drawer = document.querySelector('.gw-drawer:not([hidden])');
    if (!open_drawer || open_drawer.contains(event.target)) return;
    open_drawer.hidden = true;
    var btn = document.querySelector('[aria-controls="' + open_drawer.id + '"]');
    if (btn) btn.setAttribute('aria-expanded', 'false');
  });

  // Escape closes it too, and focus goes back to the button that opened it
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var open_drawer = document.querySelector('.gw-drawer:not([hidden])');
    if (!open_drawer) return;
    open_drawer.hidden = true;
    var btn = document.querySelector('[aria-controls="' + open_drawer.id + '"]');
    if (btn) { btn.setAttribute('aria-expanded', 'false'); btn.focus(); }
  });

  (function () {
    var root = document.querySelector('[data-gw-searchmodal]');
    if (!root) return;

    var dialog = root.querySelector('dialog');
    if (!dialog || typeof dialog.showModal !== 'function') return;

    var input = dialog.querySelector('[data-gw-suggest-input]');
    var closer = dialog.querySelector('[data-gw-searchmodal-close]');

    var panel = dialog.querySelector('[data-gw-suggest-panel]');

    // The list hangs below the field, so what bounds it is the room left under
    // the field — not a share of the viewport. Measured rather than assumed.
    function fit() {
      if (!panel || !dialog.open) return;
      var top = panel.getBoundingClientRect().top;
      var room = window.innerHeight - top - 16;
      panel.style.setProperty('--gw-suggest-max', Math.max(140, room) + 'px');
    }

    function open(event) {
      // Let a modified click through — someone opening search in a new tab
      // wants the page, not an overlay they cannot see.
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
      event.preventDefault();
      root.hidden = false;
      dialog.showModal();
      if (input) input.focus();
      fit();
    }

    window.addEventListener('resize', fit);

    // Measuring at open time reads the panel while it is still empty and sitting
    // higher than it will end up, so the ceiling comes out too generous. Measure
    // again whenever results actually land in it.
    if (panel && 'MutationObserver' in window) {
      new MutationObserver(fit).observe(panel, { childList: true });
    }

    document.querySelectorAll('[data-gw-search-open]').forEach(function (link) {
      link.addEventListener('click', open);
    });

    // Leaving is animated too, so every way out goes through here: the class
    // plays the exit, and the dialog really closes when it has finished. The
    // timer is the fallback for reduced motion, where no animation ever ends.
    var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function shut() {
      if (!dialog.open || dialog.classList.contains('is-closing')) return;
      // Hidden here as well as on `close`: the event is queued as a task and a
      // throttled tab can sit on it, which left the empty wrapper in the page.
      if (still) { dialog.close(); root.hidden = true; return; }
      var done = false;
      function finish() {
        if (done) return;
        done = true;
        dialog.removeEventListener('animationend', ended);
        dialog.classList.remove('is-closing');
        dialog.close();
        root.hidden = true;
      }
      function ended(event) { if (event.target === dialog) finish(); }
      dialog.addEventListener('animationend', ended);
      dialog.classList.add('is-closing');
      setTimeout(finish, 220);
    }

    if (closer) closer.addEventListener('click', shut);

    // Escape fires `cancel` and then closes at once, skipping the exit.
    dialog.addEventListener('cancel', function (event) {
      event.preventDefault();
      shut();
    });

    // Clicks land on the dialog itself only when they miss the panel inside it,
    // which is the backdrop as far as anyone looking at it is concerned.
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) shut();
    });

    dialog.addEventListener('close', function () {
      dialog.classList.remove('is-closing');
      root.hidden = true;
    });
  })();

  /* ------------------------------------------------------------------
     Behaviour that belongs to the whole site rather than to one section.

     Shopify gates a section's {% javascript %} behind a check for that
     section being on the page — `if (!__sections__["name"]) return` — so a
     rail on the product page would never have got the script that lived in
     the collection block, and the header's search modal would never have got
     the one that lived in the search section. The header is on every page, so
     this is where those two live.
     ------------------------------------------------------------------ */

  /* Arrows for every .gw-rail on the site. Section javascript is concatenated
     into one file served on every page, so this lives in one section rather
     than being copied into each one that renders a rail. */
  (function () {
    document.querySelectorAll('[data-gw-rail]').forEach(function (rail) {
      var track = rail.querySelector('[data-gw-rail-track]');
      if (!track) return;

      var prev = rail.querySelector('[data-gw-rail-prev]');
      var next = rail.querySelector('[data-gw-rail-next]');

      function scrollable() {
        return track.scrollWidth - track.clientWidth > 1;
      }

      function sync() {
        rail.classList.toggle('is-scrollable', scrollable());
        var left = track.scrollLeft;
        var max = track.scrollWidth - track.clientWidth;
        if (prev) prev.disabled = left <= 1;
        if (next) next.disabled = left >= max - 1;
      }

      // One card per press, and that card ends up in the middle of the frame.
      // It used to travel a whole page — four cards on a desktop — so three of
      // every four went by unseen, which is the opposite of what an arrow on a
      // row of pictures promises.
      function middle() {
        var box = track.getBoundingClientRect();
        return box.left + box.width / 2;
      }

      // Whichever card is nearest the middle right now is where we are; one
      // along from it is where we are going.
      function current(cards, centre) {
        var index = 0;
        var best = Infinity;
        for (var i = 0; i < cards.length; i++) {
          var r = cards[i].getBoundingClientRect();
          var d = Math.abs(r.left + r.width / 2 - centre);
          if (d < best) { best = d; index = i; }
        }
        return index;
      }

      function step(direction) {
        var cards = Array.prototype.slice.call(track.children);
        if (!cards.length) return;

        var centre = middle();
        var target = current(cards, centre) + direction;
        if (target < 0) target = 0;
        if (target > cards.length - 1) target = cards.length - 1;

        var r = cards[target].getBoundingClientRect();
        // The browser clamps this at both ends, so the first and last cards
        // simply come to rest against their edge instead of centring.
        track.scrollBy({ left: (r.left + r.width / 2) - centre, behavior: 'smooth' });
      }

      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });

      var frame = null;
      track.addEventListener('scroll', function () {
        if (frame) return;
        frame = requestAnimationFrame(function () {
          frame = null;
          sync();
        });
      }, { passive: true });

      window.addEventListener('resize', sync);
      sync();
    });
  })();

  // Bound to every [data-gw-suggest] on the page, not just the first: the
  // search page has one and the header's modal has another, and they are the
  // same thing so they run the same code.
  (function () {
    document.querySelectorAll('[data-gw-suggest]').forEach(function (scope) {
    var input = scope.querySelector('[data-gw-suggest-input]');
    var panel = scope.querySelector('[data-gw-suggest-panel]');
    if (!input || !panel) return;

    var MIN = 2;
    var timer = null;
    var controller = null;
    var index = -1;

    function rows() {
      return panel.querySelectorAll('.gw-suggest__row');
    }

    function close() {
      panel.hidden = true;
      panel.innerHTML = '';
      input.setAttribute('aria-expanded', 'false');
      index = -1;
    }

    function highlight(next) {
      var list = rows();
      if (!list.length) return;
      if (index > -1 && list[index]) list[index].setAttribute('aria-selected', 'false');
      index = (next + list.length) % list.length;
      var row = list[index];
      row.setAttribute('aria-selected', 'true');
      // scroll the PANEL, not the page
      if (row.offsetTop < panel.scrollTop) panel.scrollTop = row.offsetTop;
      var bottom = row.offsetTop + row.offsetHeight;
      if (bottom > panel.scrollTop + panel.clientHeight) {
        panel.scrollTop = bottom - panel.clientHeight;
      }
    }

    function search(term) {
      // One request in flight at a time — typing fast otherwise races and the
      // slower answer can land last and overwrite the right one.
      if (controller) controller.abort();
      controller = new AbortController();

      // Section javascript is not run through Liquid, so the route arrives on
      // the element rather than being interpolated here — which also keeps it
      // right under a locale or market prefix.
      var url = (scope.getAttribute('data-gw-suggest-url') || '/search/suggest')
        + '?q=' + encodeURIComponent(term)
        + '&section_id=gw-predictive-search'
        + '&resources[type]=product'
        + '&resources[limit]=6';

      fetch(url, { signal: controller.signal })
        .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var section = doc.querySelector('#shopify-section-gw-predictive-search');
          panel.innerHTML = section ? section.innerHTML : '';
          var has = panel.textContent.trim().length > 0;
          panel.hidden = !has;
          input.setAttribute('aria-expanded', has ? 'true' : 'false');
          index = -1;
        })
        .catch(function () { /* aborted, offline, or a bad response — stay quiet */ });
    }

    input.addEventListener('input', function () {
      var term = input.value.trim();
      clearTimeout(timer);
      if (term.length < MIN) { close(); return; }
      // Long enough to not fire on every keystroke, short enough that the list
      // is already there by the time you stop typing.
      timer = setTimeout(function () { search(term); }, 180);
    });

    input.addEventListener('keydown', function (event) {
      if (panel.hidden) return;
      if (event.key === 'ArrowDown') { event.preventDefault(); highlight(index + 1); }
      else if (event.key === 'ArrowUp') { event.preventDefault(); highlight(index - 1); }
      // Escape closes the list. Inside the search modal a second Escape then
      // closes the dialog, because this one only acts while the list is open.
      else if (event.key === 'Escape') { event.stopPropagation(); close(); }
      else if (event.key === 'Enter' && index > -1) {
        var row = rows()[index];
        if (row) { event.preventDefault(); window.location.href = row.href; }
      }
    });

    document.addEventListener('click', function (event) {
      if (!scope.contains(event.target)) close();
    });

    input.addEventListener('focus', function () {
      var term = input.value.trim();
      if (term.length >= MIN && panel.hidden) search(term);
    });
    });
  })();


  // Remember what was looked at. Stored with everything a card needs rather
  // than just a handle, so the search page can draw them without a request —
  // and the price is kept as rendered, which preserves the display currency of
  // the domain it was seen on. This lives in the header because a section's
  // javascript only runs where that section is rendered, and the search
  // section is never on a product page.
  (function () {
    var seed = document.querySelector('[data-gw-viewed]');
    if (!seed) return;
    try {
      var item = JSON.parse(seed.textContent);
      if (!item || !item.url) return;
      var KEY = 'gw-recently-viewed';
      var list = [];
      try { list = JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { list = []; }
      list = list.filter(function (x) { return x && x.url !== item.url; });
      list.unshift(item);
      localStorage.setItem(KEY, JSON.stringify(list.slice(0, 12)));
    } catch (e) { /* storage off, or a private window: not worth a fuss */ }
  })();

  // The drawing on a policy page. Shopify owns that markup, so this is the one
  // place on the site where a drawing is placed by script rather than by
  // Liquid — there is no template of ours to put it in.
  (function () {
    var container = document.querySelector('.shopify-policy__container');
    var source = document.querySelector('[data-gw-policy-art]');
    if (!container || !source) return;

    // Described rather than left blank. These are drawings of Giorgi's, not
    // bullets or rules, and a reader who cannot see them is owed the same
    // "there is a drawing of a key here" that everyone else gets.
    var ART_ALT = {
      'privacy-policy': 'Ink drawing of an old key',
      'terms-of-service': 'Ink drawing of a house with smoke rising from the chimney',
      'refund-policy': 'Ink drawing of a delivery van with a driver at the wheel',
      'shipping-policy': 'Ink drawing of a delivery van with a driver at the wheel',
      'contact-information': 'Ink drawing of a plug and its socket'
    };

    var handle = (window.location.pathname.split('/').filter(Boolean).pop() || '').toLowerCase();
    var art;
    try { art = JSON.parse(source.textContent)[handle]; } catch (e) { return; }
    if (!art) return;

    var img = document.createElement('img');
    // The handle goes on as a class: the five drawings are different shapes and
    // each needs its own size. See gw-base.css.
    img.className = 'gw-policy__icon gw-policy__icon--' + handle;
    img.src = art;
    img.alt = ART_ALT[handle] || '';
    img.draggable = false;
    img.loading = 'eager';

    var title = container.querySelector('.shopify-policy__title');
    if (title && title.nextSibling) container.insertBefore(img, title.nextSibling);
    else container.appendChild(img);
    container.classList.add('gw-policy--iconed');
  })();

  /* ------------------------------------------------------------------
     Toast, and adding to the basket without leaving the page.
     ------------------------------------------------------------------ */
  (function () {
    var toast = document.querySelector('[data-gw-toast]');
    var text = toast && toast.querySelector('[data-gw-toast-text]');
    var timer = null;

    function say(message, tone) {
      if (!toast || !text) return;
      text.textContent = message;
      toast.classList.toggle('gw-toast--error', tone === 'error');
      toast.hidden = false;
      // Force a reflow so the browser takes the hidden state as the starting
      // point of the transition. requestAnimationFrame would do it too, but it
      // does not run in a background tab — and a toast that never appears
      // because the tab was not focused is worse than no animation.
      void toast.offsetWidth;
      toast.classList.add('is-up');

      clearTimeout(timer);
      timer = setTimeout(function () {
        toast.classList.remove('is-up');
        setTimeout(function () { toast.hidden = true; }, 260);
      }, tone === 'error' ? 5000 : 3000);
    }

    document.addEventListener('gw:toast', function (event) {
      say((event.detail && event.detail.message) || '', event.detail && event.detail.tone);
    });

    // The count is rendered by Liquid, so without this it only catches up on
    // the next page load — you add something, the basket opens with it in
    // there, and the header still says nothing is.
    function countCart() {
      var spots = document.querySelectorAll('[data-gw-cart-count]');
      if (!spots.length) return Promise.resolve();
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
        .then(function (cart) {
          spots.forEach(function (spot) { spot.textContent = cart.item_count; });
        })
        .catch(function () { /* leave the old number rather than a wrong one */ });
    }

    // Anything that changes the basket says so, and the count follows.
    document.addEventListener('gw:cart:refresh', countCart);

    // Adding to the basket posts in place. The old behaviour — a full form
    // POST to /cart/add — answered with a redirect to the basket page, which
    // threw away the page someone was reading to show them a list.
    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || form.tagName !== 'FORM') return;

      var action = form.getAttribute('action') || '';
      if (action.indexOf('/cart/add') === -1) return;
      if (!window.fetch || !window.FormData) return;          // let it post normally

      var drawer = document.getElementById('gw-cart-drawer');
      if (!drawer || typeof drawer.showModal !== 'function') return;

      event.preventDefault();

      var button = form.querySelector('[name="add"]');
      if (button) button.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      })
        .then(function (r) {
          return r.json().then(function (body) {
            return r.ok ? body : Promise.reject(body);
          });
        })
        .then(function (item) {
          var title = (item && (item.product_title || item.title)) || 'It';
          say(title + ' — added to your basket');
          countCart();

          // A modal <dialog> renders in the top layer, above everything the
          // page can put on screen — so the drawer would cover the toast the
          // instant it opened. Let the confirmation be read first, then show
          // the basket.
          setTimeout(function () {
            document.dispatchEvent(new CustomEvent('gw:cart:refresh', { detail: { open: true } }));
          }, 850);
        })
        .catch(function (err) {
          // Shopify puts the real reason in `description` — usually that there
          // is not enough stock left. Saying that is more use than "failed".
          var why = (err && (err.description || err.message)) || 'That did not go through. Try again?';
          say(why, 'error');
        })
        .then(function () {
          if (button) button.disabled = false;
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  /* The steppers and the remove link work with JavaScript off — they are plain
     /cart/change links. This only upgrades them: instead of navigating away and
     throwing out anything typed into the order note, it writes the new quantity
     into the matching updates[] field and submits the basket form. */
  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-gw-qty-link]');
    if (!link) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (event.button !== 0) return;

    var form = link.closest('form');
    if (!form) return;

    var row = link.closest('.gw-basket__item');
    var input = row && row.querySelector('.gw-qty__input');
    if (!input) return;

    var update = form.querySelector('[data-gw-basket-update]');
    if (!update) return;

    event.preventDefault();
    input.value = link.getAttribute('data-gw-qty-value');
    update.click();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  if (!window.__gwCollectionBound) {
  window.__gwCollectionBound = true;
  // Sort genuinely submits: the <select> is a real GET control, and this only
  // saves the visitor a press of Apply. Without JS the noscript button does it.
  document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-gw-sort]');
    if (!select || !select.form) return;
    select.form.submit();
  });

  // Let the filter disclosure behave like one: click away or press Escape.
  document.addEventListener('click', function (event) {
    var open = document.querySelectorAll('[data-gw-filter][open]');
    for (var i = 0; i < open.length; i++) {
      if (!open[i].contains(event.target)) open[i].removeAttribute('open');
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var open = document.querySelectorAll('[data-gw-filter][open]');
    for (var i = 0; i < open.length; i++) {
      open[i].removeAttribute('open');
      var summary = open[i].querySelector('summary');
      if (summary) summary.focus();
    }
  });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page"]) return;
  try {
    
  // Pictures the client pasted into the page body move to a column of their
  // own on a desktop. A comment node is left where each one sat, so going back
  // to a narrow window restores the original order exactly rather than
  // guessing at it.
  (function () {
    var page = document.querySelector('.gw-page');
    if (!page) return;
    var rte = page.querySelector('.gw-rte');
    if (!rte || page.classList.contains('gw-page--pictured')) return;

    // Blocks that are only a picture. A paragraph with words round the image
    // belongs in the text and stays there.
    var blocks = Array.prototype.slice.call(rte.children).filter(function (el) {
      return el.querySelector && el.querySelector('img') && el.textContent.trim() === '';
    });
    if (!blocks.length) return;

    var marks = blocks.map(function (block) {
      var mark = document.createComment('gw-aside');
      block.parentNode.insertBefore(mark, block);
      return mark;
    });

    var aside = document.createElement('aside');
    aside.className = 'gw-page__aside';

    // The page's own drawing lives in the right-hand column too, and so does
    // this one — both were placed in grid column 2 spanning every row, so on
    // Shipping & Returns the van sat directly on top of the photographs. It
    // travels with them instead: first item in the column, pictures under it.
    var icon = page.querySelector('.gw-page__icon');
    var iconMark = null;
    if (icon) {
      iconMark = document.createComment('gw-icon');
      icon.parentNode.insertBefore(iconMark, icon);
    }

    var wide = window.matchMedia('(min-width: 901px)');
    function apply() {
      if (wide.matches) {
        if (!aside.parentNode) page.appendChild(aside);
        if (icon) aside.appendChild(icon);
        blocks.forEach(function (block) { aside.appendChild(block); });
        page.classList.add('gw-page--aside');
      } else {
        if (icon && iconMark) iconMark.parentNode.insertBefore(icon, iconMark);
        blocks.forEach(function (block, i) {
          marks[i].parentNode.insertBefore(block, marks[i]);
        });
        if (aside.parentNode) aside.parentNode.removeChild(aside);
        page.classList.remove('gw-page--aside');
      }
    }

    apply();
    if (wide.addEventListener) wide.addEventListener('change', apply);
    else if (wide.addListener) wide.addListener(apply);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-gw-gallery]').forEach(function (gallery) {
      var track = gallery.querySelector('[data-gw-gallery-track]');
      if (!track) return;

      var slides = gallery.querySelectorAll('.gw-gallery__slide');
      var prev = gallery.querySelector('[data-gw-gallery-prev]');
      var next = gallery.querySelector('[data-gw-gallery-next]');
      var thumbs = gallery.querySelectorAll('[data-gw-gallery-thumb]');
      if (!slides.length) return;

      // Positions are measured off the slides themselves, never computed as
      // index x track width. The track has a gap between slides, so the old
      // arithmetic was short by one gap per step: the first click looked
      // right, the second sat a little off, and by the fifth the image was
      // visibly adrift. Measuring also means this works whatever a slide is
      // as wide as, which is what lets one set of rules serve the phone and
      // the desktop rather than two that drift apart.
      //
      // Everything still reads the track's own overflow rather than a
      // breakpoint, so a layout that cannot scroll sideways quietly reports
      // index 0 and the controls it does not render stay out of it.

      // Where the track must be scrolled to for this slide to sit in the
      // middle of it, clamped so the first and last do not pull in a band of
      // empty space at either end.
      function offsetFor(el) {
        var centred = el.offsetLeft - (track.clientWidth - el.offsetWidth) / 2;
        var most = track.scrollWidth - track.clientWidth;
        return Math.max(0, Math.min(centred, most));
      }

      // The slide whose middle is nearest the middle of the track — which is
      // the one you are actually looking at, however far the scroll has come.
      function index() {
        var middle = track.scrollLeft + track.clientWidth / 2;
        var best = 0;
        var bestGap = Infinity;
        for (var n = 0; n < slides.length; n++) {
          var gap = Math.abs((slides[n].offsetLeft + slides[n].offsetWidth / 2) - middle);
          if (gap < bestGap) { bestGap = gap; best = n; }
        }
        return best;
      }

      // scrollTo on the TRACK, never scrollIntoView and never focus() on a
      // slide: both of those scroll the PAGE back up to the gallery, which is
      // exactly the jump a thumbnail tap must not cause.
      function go(i) {
        var clamped = Math.max(0, Math.min(i, slides.length - 1));
        track.scrollTo({ left: offsetFor(slides[clamped]), behavior: 'smooth' });
      }

      function sync() {
        var i = index();
        thumbs.forEach(function (thumb, n) {
          thumb.setAttribute('aria-current', n === i ? 'true' : 'false');
        });
        if (prev) prev.disabled = i <= 0;
        if (next) next.disabled = i >= slides.length - 1;
      }

      if (prev) prev.addEventListener('click', function () { go(index() - 1); });
      if (next) next.addEventListener('click', function () { go(index() + 1); });
      thumbs.forEach(function (thumb, n) {
        thumb.addEventListener('click', function () { go(n); });
      });

      // Snap scrolling fires a lot; one frame is plenty to keep the dots and
      // the arrow states honest.
      var frame = null;
      track.addEventListener('scroll', function () {
        if (frame) return;
        frame = requestAnimationFrame(function () {
          frame = null;
          sync();
        });
      }, { passive: true });

      window.addEventListener('resize', sync);
      sync();
    });
  })();

  (function () {
    var bar = document.querySelector('[data-gw-buybar]');
    var cta = document.querySelector('[data-gw-cta]');
    if (!bar || !cta || !('IntersectionObserver' in window)) return;

    bar.hidden = false;

    function show(up) {
      bar.classList.toggle('is-up', up);
    }

    // The bar stands in for the real button, so it arrives the moment the real
    // one goes behind the header — not when it leaves the foot of the screen,
    // which on a long product page left a screen and a half with no way to buy.
    //
    // An observer rather than a scroll handler: scroll events are the thing
    // browsers suppress first in a tab you are not looking at, and coming back
    // to a stale bar is exactly the failure this is meant to prevent.
    var header = document.querySelector('.gw-header');
    var watcher = null;

    function watch() {
      if (watcher) watcher.disconnect();
      // The root's top edge is pulled down to the header's bottom, so "out of
      // view" here means "behind the header". Read rather than assumed,
      // because the wordmark hangs below the bar and the two differ.
      var edge = header ? Math.round(header.getBoundingClientRect().height) : 0;

      watcher = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          // Out of view below the fold is not covered — it is simply further
          // down the page, and the bar has no business appearing yet.
          var above = entry.rootBounds
            ? entry.boundingClientRect.bottom <= entry.rootBounds.top + 1
            : entry.boundingClientRect.bottom <= edge + 1;
          show(!entry.isIntersecting && above);
        });
      }, { rootMargin: (-edge) + 'px 0px 0px 0px', threshold: 0 });

      watcher.observe(cta);
    }

    window.addEventListener('resize', watch);
    watch();
  })();

  // One-option products choose their variant with radios and no reload, so
  // the button has to follow the choice: an out-of-stock variant is a
  // pre-order, with the line property that says so and without express
  // checkout, which would skip the basket.
  (function () {
    var form = document.querySelector('.gw-pdp__form');
    if (!form) return;
    var radios = form.querySelectorAll('.gw-pdp__radio');
    if (!radios.length) return;
    var row = form.querySelector('.gw-pdp__ctarow');

    function follow() {
      var chosen = form.querySelector('.gw-pdp__radio:checked');
      if (!chosen) return;
      var pre = chosen.getAttribute('data-in-stock') === 'false';

      document.querySelectorAll('[data-gw-add]').forEach(function (button) {
        button.textContent = button.getAttribute(pre ? 'data-label-pre' : 'data-label-add');
      });

      var flag = form.querySelector('[data-gw-preorder-flag]');
      if (pre && !flag && row) {
        flag = document.createElement('input');
        flag.type = 'hidden';
        flag.name = 'properties[Order type]';
        flag.value = 'Pre-order';
        flag.setAttribute('data-gw-preorder-flag', '');
        row.appendChild(flag);
      } else if (!pre && flag) {
        flag.remove();
      }

    }

    radios.forEach(function (radio) { radio.addEventListener('change', follow); });
    follow();
  })();

  // See details: make sure the row it points at is open before the jump.
  (function () {
    document.querySelectorAll('[data-gw-details-link]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        var target = document.getElementById('gw-pdp-details');
        var first = target && target.querySelector('.gw-acc__row');
        if (first) first.open = true;
        if (!target || !target.scrollIntoView) return;       // the plain anchor still works
        event.preventDefault();
        var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: still ? 'auto' : 'smooth', block: 'start' });
      });
    });
  })();

  // The bar's size chips are labels for the form's radios, so the browser does
  // the choosing. This only moves the highlight, and listens on the document so
  // it catches a change made anywhere — the chips up the page or the ones down
  // here.
  (function () {
    var bar = document.querySelector('[data-gw-buybar-sizes]');
    if (!bar) return;
    var chips = bar.querySelectorAll('[data-gw-buybar-size]');
    document.addEventListener('change', function (event) {
      var radio = event.target;
      if (!radio || radio.name !== 'id') return;
      chips.forEach(function (chip) {
        chip.classList.toggle('chip--on', chip.getAttribute('data-gw-buybar-size') === radio.value);
      });
    });
  })();

  (function () {
    var rows = document.querySelectorAll('.gw-acc__row');
    if (!rows.length) return;

    // Opening a row glides just far enough to bring the rest of its text into
    // view. Closing does nothing — collapsing already moves everything under
    // your cursor, and moving the page as well would be two surprises at once.
    function reveal(row) {
      var column = row.closest('.gw-pdp__info');
      var scrolls = column
        && column.scrollHeight > column.clientHeight + 1
        && getComputedStyle(column).overflowY === 'auto';

      var rect = row.getBoundingClientRect();
      var margin = 14;

      if (scrolls) {
        var box = column.getBoundingClientRect();
        var below = rect.bottom - box.bottom + margin;
        // Never travel so far that the summary you just clicked leaves the top.
        var room = rect.top - box.top;
        if (below > 0) column.scrollBy({ top: Math.min(below, room), behavior: 'smooth' });
        return;
      }

      // The page is the scroller. On a phone the sticky buy bar owns the
      // bottom strip, so the row has to clear that too.
      var bar = document.querySelector('.gw-buybar.is-up');
      var floor = window.innerHeight - (bar ? bar.offsetHeight : 0);
      var overflow = rect.bottom - floor + margin;
      var headroom = rect.top - 8;
      if (overflow > 0) window.scrollBy({ top: Math.min(overflow, headroom), behavior: 'smooth' });
    }

    rows.forEach(function (row) {
      row.addEventListener('toggle', function () {
        if (!row.open) return;
        // One frame, so the panel has its height before anything is measured.
        requestAnimationFrame(function () { reveal(row); });
      });
    });
  })();

  // ---- Size chart ----
  //
  // The trigger ships hidden and is revealed here, so a browser that cannot
  // run this — or cannot do <dialog> — never shows a button that would do
  // nothing. Everything the chart says is also in the description, so there is
  // nothing to fall back to and nothing lost.
  (function () {
    var root = document.querySelector('[data-gw-sizemodal]');
    if (!root) return;

    var dialog = root.querySelector('dialog');
    if (!dialog || typeof dialog.showModal !== 'function') return;

    var openers = document.querySelectorAll('[data-gw-sizemodal-open]');
    if (!openers.length) return;

    var closer = dialog.querySelector('[data-gw-sizemodal-close]');
    var opener_used = null;
    var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function open(event) {
      opener_used = event.currentTarget;
      root.hidden = false;
      dialog.showModal();
    }

    // Every way out goes through here so the exit animation always plays, and
    // focus always lands back on the button that was pressed rather than at
    // the top of the document.
    function shut() {
      if (!dialog.open || dialog.classList.contains('is-closing')) return;
      function finish() {
        dialog.removeEventListener('animationend', ended);
        dialog.classList.remove('is-closing');
        dialog.close();
        root.hidden = true;
        if (opener_used) opener_used.focus();
      }
      if (still) { finish(); return; }
      var done = false;
      function ended(event) {
        if (event.target !== dialog || done) return;
        done = true;
        finish();
      }
      dialog.addEventListener('animationend', ended);
      dialog.classList.add('is-closing');
      setTimeout(function () { if (!done) { done = true; finish(); } }, 220);
    }

    openers.forEach(function (button) {
      button.hidden = false;
      button.addEventListener('click', open);
    });

    if (closer) closer.addEventListener('click', shut);

    // Escape fires `cancel` and would close at once, skipping the exit.
    dialog.addEventListener('cancel', function (event) {
      event.preventDefault();
      shut();
    });

    // The dialog fills the viewport, so a click outside the panel is a click
    // on the dialog itself. That is the backdrop, and it means "close".
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) shut();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  // The search page answers in its own grid. Typing replaces it; clearing the
  // field puts back what was there before — recently viewed, then the picks.
  (function () {
    var scope = document.querySelector('[data-gw-search-url]');
    if (!scope) return;

    var input = scope.querySelector('[data-gw-search-input]');
    var live = document.querySelector('[data-gw-search-live]');
    var panes = document.querySelectorAll('[data-gw-search-pane]');
    if (!input || !live) return;

    var MIN = 2;
    var timer = null;
    var controller = null;

    function showPanes(on) {
      panes.forEach(function (pane) {
        // A pane that was hidden for its own reasons — no recently viewed —
        // must stay hidden, so its own flag is remembered separately.
        if (pane.hasAttribute('data-gw-empty')) return;
        pane.hidden = !on;
      });
    }

    function clear() {
      live.hidden = true;
      live.innerHTML = '';
      showPanes(true);
    }

    function search(term) {
      if (controller) controller.abort();
      controller = new AbortController();

      // The real search, not /search/suggest: suggest stops at ten however
      // many things match, and this grid is meant to be everything.
      var url = (scope.getAttribute('data-gw-search-url') || '/search')
        + '?q=' + encodeURIComponent(term)
        + '&type=product'
        + '&options%5Bprefix%5D=last'
        + '&section_id=gw-search-grid';

      fetch(url, { signal: controller.signal })
        .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var section = doc.querySelector('#shopify-section-gw-search-grid');
          live.innerHTML = section ? section.innerHTML : '';
          var has = live.textContent.trim().length > 0;
          live.hidden = !has;
          showPanes(!has);
        })
        .catch(function () { /* aborted or offline: leave what is there */ });
    }

    // With the grid answering live there is nothing left for a submit to do
    // but reload the page onto the same answer, so the form stays put.
    var form = input.form;
    if (form) {
      form.addEventListener('submit', function (event) {
        if (input.value.trim().length >= MIN) event.preventDefault();
      });
    }

    input.addEventListener('input', function () {
      var term = input.value.trim();
      clearTimeout(timer);
      if (term.length < MIN) { clear(); return; }
      timer = setTimeout(function () { search(term); }, 180);
    });
  })();

  // Draw the recently viewed. The recording happens in the header, because a
  // section's javascript only runs on pages where that section is rendered —
  // this one is never on a product page, which is the only place there is
  // anything to record.
  (function () {
    var KEY = 'gw-recently-viewed';
    var MAX = 4;

    function read() {
      try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
    }

    var pane = document.querySelector('[data-gw-recent]');
    var grid = document.querySelector('[data-gw-recent-grid]');
    if (!pane || !grid) return;

    var items = read().slice(0, MAX);
    if (!items.length) {
      // Nothing seen yet. Flag it so the live search does not later reveal an
      // empty heading when the field is cleared.
      pane.setAttribute('data-gw-empty', '');
      return;
    }

    items.forEach(function (item) {
      var a = document.createElement('a');
      a.className = 'gw-card';
      a.href = item.url;

      var media = document.createElement('div');
      media.className = 'media media--4x5 card__media';
      if (item.image) {
        var img = document.createElement('img');
        img.src = item.image;
        img.alt = '';
        img.loading = 'lazy';
        media.appendChild(img);
      }

      var title = document.createElement('h3');
      title.className = 'card__title';
      title.textContent = item.title || '';

      var price = document.createElement('p');
      price.className = 'card__price';
      price.textContent = item.price || '';

      a.appendChild(media);
      a.appendChild(title);
      a.appendChild(price);
      grid.appendChild(a);
    });

    pane.hidden = false;
  })();


  // Sorting submits on change. The Apply button is the no-JS fallback and is
  // removed here rather than hidden in CSS, so it never sits in the tab order.
  document.querySelectorAll('[data-gw-search-controls]').forEach(function (form) {
    var apply = form.querySelector('[data-gw-search-apply]');
    if (apply) apply.remove();

    form.querySelectorAll('select').forEach(function (select) {
      select.addEventListener('change', function () {
        form.submit();
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
